var _excluded = ["alt", "sourceSet", "source", "crossOrigin", "onLoad", "className"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback } from 'react';

function Image(_ref) {
  var alt = _ref.alt,
      sourceSet = _ref.sourceSet,
      source = _ref.source,
      crossOrigin = _ref.crossOrigin,
      onLoad = _ref.onLoad,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var finalSourceSet = sourceSet ? sourceSet.map(function (_ref2) {
    var subSource = _ref2.source,
        descriptor = _ref2.descriptor;
    return "".concat(subSource, " ").concat(descriptor);
  }).join(',') : null;
  var handleLoad = useCallback(function () {
    if (onLoad) onLoad();
  }, [onLoad]);
  return /*#__PURE__*/React.createElement("img", Object.assign({
    alt: alt,
    src: source,
    crossOrigin: crossOrigin,
    className: className,
    onLoad: handleLoad
  }, finalSourceSet ? {
    srcSet: finalSourceSet
  } : {}, rest));
}

export { Image };